export const posters24 = [
    {
        id: 1,
        title: "SOLAR - Goethe University",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bdh-poster-stockholm.png",

        pdf: "",
    },
    {
        id: 2,
        title: "miRADAR - Wageningen University & Research",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bfh-poster-wageningen.png",

        pdf: "",
    },
    {
        id: 3,
        title: "Hydro Guardians - Leibnitz Universität Hannover  ",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bfh-poster-hannover.png",

        pdf: "",
    },
    {
        id: 4,
        title: "Eskape - Albert Ludwigs University of Freiburg",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bfh-poster-freiburg.png",

        pdf: "",
    },
    {
        id: 5,
        title: "PROMISE - Eindhoven University of Technology",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bfh-poster-eindhoven.png",

        pdf: "",
    },
    {
        id: 6,
        title: "EndoSense - DTU Biobuilders",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bfh-poster-dtu.png  ",

        pdf: "",
    },
    {
        id: 7,
        title: "PreCyse - Bielefeld University ",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bfh-poster-bielefeld-1.png",

        pdf: "",
    },
    {
        id: 8,
        title: "Engineering Flower Colors - Technical University Braunschweig",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bfh-poster-synbio-compressed.webp",

        pdf: "",
    },

    {
        id: 9,
        title: "Neominex - KU Leuven",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bfh-poster-leuven.png",

        pdf: "",
    },
    {
        id: 10,
        title: "BioGlimmer - iGEM Stockholm",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bdh-poster-stockholm.png",

        pdf: "",
    },
    {
        id: 11,
        title: "ReFiBa - Technical University Dresden",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bfh-poster-dresden.png",

        pdf: "",
    },
    {
        id: 12,
        title: "syntcoLAB - UCLouvain",
        thumbnail: "https://static.igem.wiki/teams/5628/posters/pngs/uclouvain.webp",

        pdf: "https://static.igem.wiki/teams/5628/posters/louvain.pdf",
    },

    {
        id: 13,
        title: "MusselDox - University of Helsinki & Aalto University",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/posters-and-stuff/bfh-poster-helsinki.png",

        pdf: "",
    },
]